<template>
  <button
    type="button"
    class="lg-toggle"
    role="switch"
    :aria-checked="modelValue"
    :aria-label="label"
    :disabled="disabled"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span class="lg-toggle-track" :class="{ on: modelValue }">
      <span class="lg-toggle-thumb" />
    </span>
    <span v-if="$slots.default" class="lg-toggle-text"><slot /></span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean;
  label?: string;
  disabled?: boolean;
}>();

defineEmits<{ 'update:modelValue': [value: boolean] }>();
</script>

<style scoped>
.lg-toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--lg-space-2);
  min-height: var(--lg-touch);
  padding: 0;
  background: none;
  border: none;
  color: var(--lg-text);
  font-family: var(--lg-font-sans);
  font-size: var(--lg-fs-md);
  cursor: pointer;
}
.lg-toggle:disabled {
  opacity: 0.55;
  cursor: default;
}
.lg-toggle-track {
  position: relative;
  width: 38px;
  height: 22px;
  flex-shrink: 0;
  border-radius: var(--lg-radius-pill);
  background: var(--lg-bg-surface);
  border: 1px solid var(--lg-border-strong);
  transition:
    background var(--lg-dur-base) var(--lg-ease),
    border-color var(--lg-dur-base) var(--lg-ease);
}
.lg-toggle-track.on {
  background: var(--lg-accent);
  border-color: var(--lg-accent);
}
.lg-toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: var(--lg-radius-pill);
  background: var(--lg-text);
  transition: transform var(--lg-dur-base) var(--lg-ease);
}
.lg-toggle-track.on .lg-toggle-thumb {
  transform: translateX(16px);
  background: var(--lg-accent-fg);
}
.lg-toggle:focus-visible .lg-toggle-track {
  outline: none;
  box-shadow: var(--lg-focus);
}
</style>
